import { render } from "./CountDown.vue?vue&type=template&id=2d8a01a1"
import script from "./CountDown.vue?vue&type=script&lang=js"
export * from "./CountDown.vue?vue&type=script&lang=js"

import "./CountDown.vue?vue&type=style&index=0&id=2d8a01a1&lang=css"

import exportComponent from "/Users/martinflores/Documents/kitsuu-landing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__